'use client';

import type { ReactNode } from 'react';

import { HorizontalScroll } from '@/components/client';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';

const AUTOPLAY_OPTIONS = {
  delay: 3000,
  stopOnInteraction: false,
  stopOnMouseEnter: true,
};

const MOBILE_START_INSET = 20;

//* 루프는 컨테이너 padding을 이음매 간격에 넣으므로 모바일 왼쪽 20 여백은 정렬 오프셋으로 준다
const alignWithMobileInset = () => MOBILE_START_INSET;

export const GoodsGiftRollingCarousel = ({
  children,
}: {
  children: ReactNode;
}) => {
  const isMobileTablet = useMediaQuery(BREAKPOINTS.MOBILE_TABLET);

  return (
    <HorizontalScroll
      loop
      autoplay={AUTOPLAY_OPTIONS}
      align={isMobileTablet ? alignWithMobileInset : 'start'}
      className="mobile-tablet:-mx-20"
    >
      {children}
    </HorizontalScroll>
  );
};
